/**
 * @desc 获取运行记录对应的帆软url
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 类型(1:A窑-回转窑托轮温度记录表;2:B窑-回转窑托轮温度记录表) */
  type: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.RunRecordUrlResponse>> {
  return defHttp.get({
    url: '/web/runrecord/url',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.RunRecordUrlResponse>> {
  return defHttp.get({
    url: '/mock/web/runrecord/url',

    params,
  });
}
